export default {
  namespaced: true,
  traffic: {
    title: "traffic",
    counter: "contador",
    reset: "reiniciar o contador",
    request: "petição",
    created: "primeira conexão",
    imei: "imei",
    ip: "ip",
    alarm: "alarme",
    with_counter: "tráfego com contadores",
    without_counter: "tráfego sem contadores",
    updatedAt: "última atualização"
  },
};
